// extracted by mini-css-extract-plugin
export default {"DropDown":"styles_DropDown__6wWgJ"};